import PropTypes from 'prop-types'

const Toggle = ({ onToggleClick, toggleOn }) => {
  return (
    <i
      onClick={onToggleClick}
      className={`fa fa-toggle-${toggleOn ? 'on' : 'off'}`}
      aria-hidden="true"
    />
  )
}

Toggle.propTypes = {
  onToggleClick: PropTypes.func,
  toggleOn: PropTypes.bool
}

export default Toggle
